{
  "title": "Giant Insect",
  "source": "Player's Handbook",
  "levelAndSchool": "4th-level transmutation",
  "level": 4,
  "castingTime": "1 action",
  "range": "30 feet",
  "components": "V, S",
  "duration": "Concentration, up to 10 minutes",
  "description": [
    "You transform up to ten centipedes, three spiders, five wasps, or one scorpion within range into giant versions of their natural forms for the duration. A centipede becomes a giant centipede, a spider becaomes a giant spider, a wasp becomes a giant wasp, and a scorpion becomes a giant scorpion.",
    "Each creature obeys your verbal commands, and in combat, they act on your turn each round. The DM has the statistics for these creatures and resolves their actions and movement.",
    "A creature remains in its giant size for the duration, until it drops to 0 hit points, or until you use an action to dismiss the effect on it.",
    "The DM might allow you to choose different targets. For example, if you transform a bee, its giant version might have the same statistics as a giant wasp."
  ],
  "spellLists": ["druid"]
}
